import PropTypes from 'prop-types';
import React from 'react';

import 'vdp-used/components/DrivePowerTrainAndColourSection/DrivePowerTrainAndColour/DrivePowerTrainAndColour.scss';

const DrivePowerTrainAndColour = ({ iconClass, imageUrl, label, title, colorValue }) => {
    const icon = iconClass && <icon className={iconClass} />;
    let image;
    image = imageUrl && <img className="vdp-used-specs-single-color-img" src={imageUrl} alt={label} />;
    image = colorValue && (
        <div style={{ 'background-color': colorValue }} className="vdp-used-specs-single--image__hex" />
    );

    return (
        <div className="vdp-used-specs-single">
            <div className="vdp-used-specs-single--image">
                {icon}
                {image}
            </div>
            <div className="vdp-used-specs-single--info">
                <div className="vdp-used-specs-single--info__title">{title}</div>
                <div className="vdp-used-specs-single--info__label">{label}</div>
            </div>
        </div>
    );
};

DrivePowerTrainAndColour.defaultProps = {
    iconClass: '',
    imageUrl: '',
    colorValue: null,
};

DrivePowerTrainAndColour.propTypes = {
    iconClass: PropTypes.string,
    imageUrl: PropTypes.string,
    label: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    colorValue: PropTypes.string,
};

DrivePowerTrainAndColour.displayName = 'DrivePowerTrainAndColour';

export default DrivePowerTrainAndColour;
